import { authorizedFetch } from './api-client';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface UserProfile {
  id: string;
  email: string;
  name: string;
  role: string;
  level: number;
  company_id: string | null;
  clinic_ids: string[];
  permissions: string[];
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
  user?: UserProfile | null;
}

export async function loginWithGoogle(googleToken: string): Promise<LoginResponse> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/login/`, {
    method: 'POST',
    body: JSON.stringify({ google_token: googleToken }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Erro ao fazer login');
  }

  return response.json();
}
